import type { Comment } from "@/mocks/comments";

interface CommentCardProps {
  comment: Comment;
}

export default function CommentCard({ comment }: CommentCardProps) {
  return (
    <div className="bg-white rounded-lg p-5">
      <div className="flex items-center gap-3 mb-3">
        <div
          className={`w-10 h-10 rounded-full ${comment.avatarBg} flex items-center justify-center flex-shrink-0`}
        >
          <span className="text-white font-bold text-sm">
            {comment.userName.charAt(0)}
          </span>
        </div>
        <div className="min-w-0">
          <p className="font-medium text-foreground-900 text-sm truncate">
            {comment.userName}
          </p>
          <p className="text-foreground-400 text-xs truncate">{comment.userHandle}</p>
        </div>
      </div>
      <p className="text-foreground-600 text-sm leading-relaxed">
        &ldquo;{comment.content}&rdquo;
      </p>
      <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200">
        <span className="text-foreground-400 text-xs">{comment.time}</span>
        <span className="flex items-center gap-1 text-foreground-400 text-xs">
          <i className="ri-heart-line"></i>
          {comment.likes}
        </span>
      </div>
    </div>
  );
}